import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  csv: { marginBottom: theme.spacing() },
  appreciate: { display: "inline-flex", alignItems: "center" },
}));
